import * as React from 'react';
import { navigate } from 'router';

import CurrentSaleInjector from '~/apps/shared/containers/sale/CurrentSaleInjector';
import SalePrint from '../../components/sales/SalePrint';

export default function() {
  return (
    <CurrentSaleInjector
      component={SalePrint}
      // saleId={null}
      onReturn={() => navigate('pos.admin.sales')}
    />
  );
};
